import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import AddressCard from './AddressCard';
import { useSelector } from 'react-redux';
import { apiService } from '../../client/common/apiCallService';
import { JncCryptoAddresses } from '../../client/Juno/client/tables/addresses/JncCryptoAddressModal';
import { JncCryptoAddressView } from '../../client/Juno/client/tables/addresses/JncCryptoAddressView';
import { BalanceCryptoSend } from '../../client/Juno/client/tables/balances/actions/crypto/BalanceCryptoSend';
import { JncDelete } from '../../client/Juno/client/components/global/JncDelete';
import { useLocation, useNavigate } from 'react-router-dom';
import { useJunoCommonFunctions } from '../../client/Juno/helpers';
import AddNewAddress from './wallet/AddNewAddress';
import ManageWalletAddress from './wallet/ManageWalletAddress';
import JunoButton from './common/JunoButton';
import { Add } from '@mui/icons-material';
import EmptyCardState from './common/EmptyCardState';

export default function SavedAddressSection({ isDashboard }) {
    const apiUrl = useSelector(state => state.config.api_url);
    const clientData = useSelector(state => state.juno.clientData);
    const navigate = useNavigate();
    const location = useLocation();
    const [wallets, setWallets] = useState([]);
    const [selectedWallet, setSelectedWallet] = useState({});
    const readOnly = clientData && clientData.readOnly ? clientData.readOnly : false;
    const { useWindowWidth } = useJunoCommonFunctions();
    const windowWidth = useWindowWidth();
    const [openModal, setOpenModal] = useState({
        viewWallet: false,
        editWallet: false,
        addWallet: false,
        deleteWallet: false,
        sendCrypto: false,
    });
    const [isAddressPage, setIsAddressPage] = useState(false);

    const url = `${window.location.hostname === 'localhost' ? apiUrl : ''}/restapi`;

    const getWallets = () => {
        apiService(
            `${url}/get-crypto-address`,
            {
                clientId: clientData.clientId,
            },
            dt => {
                if (dt) {
                    setWallets(dt);
                }
            },
            err => {
                console.log(err);
            },
        );
    };

    useEffect(() => {
        if (location.pathname === '/client/address') setIsAddressPage(true);
        if (!clientData) return;
        getWallets();
    }, [clientData]);

    const handleSelectWallet = wallet => {
        setSelectedWallet(wallet);
        setOpenModal({ ...openModal, viewWallet: true });
    };

    const handleSeeAll = () => {
        navigate('/client/address');
    };

    const closeModal = modal => {
        setOpenModal(prevState => ({ ...prevState, [modal]: false }));
    };

    return (
        <div className=" border !border-section-br rounded-lg lg:!m-1 lg:!mt-[3.5px]">
            <div
                className={`${
                    !isAddressPage &&
                    'rounded-lg border !border-section-br lg-border-0 p-4 my-1 bg-[#FFFFFF] dark:bg-[#26272B]'
                }  mt-0 mb-0 `}>
                {!isAddressPage ? (
                    <div className="flex items-center justify-between mb-4 ">
                        <Typography
                            variant="subtitle1"
                            className="text-section-title font-semibold !text-sm uppercase !font-inter">
                            Saved Addresses
                            {wallets.length ? (
                                <span className="ml-2 bg-[#eaecf0] dark:bg-[#51525C] !text-primary rounded-md px-2 py-1 ">
                                    {wallets.length}
                                </span>
                            ) : null}
                        </Typography>

                        {wallets.length ? (
                            <JunoButton
                                className="!w-[66px] text-xs !p-0 !h-7 font-semibold hidden lg:block"
                                type="secondary"
                                onClick={handleSeeAll}>
                                See all
                            </JunoButton>
                        ) : null}

                        <div className="block lg:hidden">
                            <Add
                                className="text-balanceCard-manage cursor-pointer"
                                onClick={() => {
                                    if (readOnly) return;
                                    setOpenModal(prevState => ({
                                        ...prevState,
                                        addWallet: true,
                                    }));
                                }}
                            />
                        </div>
                    </div>
                ) : (
                    <div>
                        <div className="flex h-[52px] px-4 py-[14px] justify-between items-center rounded-b-lg mb-1 bg-filterPannel-bg lg:hidden border !border-section-br ">
                            <div className="flex items-center space-x-2 my-4">
                                <h2 className="text-lg font-semibold text-section-title uppercase">
                                    Address book
                                </h2>
                                {wallets.length ? (
                                    <span className="ml-2 bg-[#eaecf0] dark:bg-[#51525C] !text-primary rounded-md px-2 py-1">
                                        {wallets.length}
                                    </span>
                                ) : null}
                            </div>
                            <Add
                                className="text-balanceCard-manage cursor-pointer lg:hidden"
                                onClick={() => {
                                    if (readOnly) return;
                                    setOpenModal(prevState => ({
                                        ...prevState,
                                        addWallet: true,
                                    }));
                                }}
                            />
                        </div>
                        <div className="hidden lg:flex bg-filterPannel-bg !px-6 !py-4">
                            <h2 className="text-lg font-semibold text-section-title uppercase">
                                Address book
                            </h2>
                            {wallets.length ? (
                                <span className="ml-2 bg-[#eaecf0] dark:bg-[#51525C] !text-primary rounded-md px-2 py-1">
                                    {wallets.length}
                                </span>
                            ) : null}
                        </div>
                    </div>
                )}

                <div
                    className={`grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-1 bg-filterPannel-bg lg:border-0 lg:rounded-0 md:border md:!border-section-br xxs:rounded-lg ${!isDashboard && 'px-6 py-3'}`}>
                    {/* Add Wallet Card - Only visible on large screens */}
                    <div className="hidden lg:block">
                        <EmptyCardState
                            cardHeading={'ADD WALLET ADDRESS'}
                            onClick={() => {
                                setOpenModal(prevState => ({
                                    ...prevState,
                                    addWallet: true,
                                }));
                            }}
                            readOnly={readOnly}
                            className="h-[132px]"
                        />
                    </div>

                    {wallets.map((wallet, idx) => (
                        <AddressCard
                            key={idx}
                            wallet={wallet}
                            onClick={() => handleSelectWallet(wallet)}
                            readOnly={readOnly}
                        />
                    ))}
                </div>

                {!isAddressPage && wallets.length ? (
                    <Typography
                        onClick={handleSeeAll}
                        className="!font-inter lg:hidden mt-3 text-center text-sm !text-text font-semibold !bg-secondary rounded-sm px-2 py-1 cursor-pointer hover:text-gray-800">
                        SEE ALL
                    </Typography>
                ) : null}

                {openModal.viewWallet && (
                    <ManageWalletAddress
                        onClose={() => closeModal('viewWallet')}
                        open={openModal.viewWallet}
                        address={selectedWallet?.address}
                        cryptoName={`${selectedWallet?.blockchain} (${selectedWallet?.cryptoId})`}
                        addressNickName={selectedWallet?.nickName}
                        cryptoId={selectedWallet?.cryptoId}
                        addressId={selectedWallet?._id}
                        getCryptoAddress={getWallets}
                        blockchain={selectedWallet?.blockchain}
                    />
                )}

                {openModal.addWallet && (
                    <AddNewAddress
                        bottomText={'add new address'}
                        onBottomClick={() => closeModal('addWallet')}
                        heading={'add new address'}
                        cryptoList={selectedWallet}
                        getCryptoAddress={getWallets}
                        close={() => closeModal('addWallet')}
                        open={openModal.addWallet}
                    />
                )}

                {openModal.sendCrypto && (
                    <BalanceCryptoSend
                        walletAddress={selectedWallet.address}
                        cryptoId={selectedWallet.cryptoId}
                        onClose={() => closeModal('sendCrypto')}
                        open={openModal.sendCrypto}
                    />
                )}
            </div>
        </div>
    );
}
